import { createApp, markRaw } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHeart,
  faCoffee,
  faSpinner,
  faEdit,
  faTrashAlt,
  faCopy,
  faPlus,
  faPlay,
  faPause,
  faBars,
  faClock,
  faDollarSign,
  faToolbox,
  faUser,
  faRadiation,
  faBaby,
  faAngry,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import vuetify from 'vuetify'
import Navbar from "./components/Navbar.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueCookies from "vue-cookies";
import { createPinia } from "pinia";
import dayjs from "dayjs";
import VueAwesomePaginate from "vue-awesome-paginate";
import entriesHistory from "@/components/entriesHistory.vue";
import clientsChart from "@/components/clientsCharts.vue";
import Dashboard from "@/components/Dashboard.vue";
import ExportModule from "@/components/ExportModule.vue";
import Header from "@/components/Header.vue";
import OfferedAnalysis from "@/components/OfferedAnalysis.vue";
import OfferedCampaigns from "@/components/OfferedCampaigns.vue";
import PersonnalReports from "@/components/personnal-reports.vue";
import ProductList from "@/components/ProductList.vue";
import UsageByEntities from "@/components/UsageByEntities.vue";
import vuetify from "./plugins/vuetify";

// css and scss imports
import "bootstrap/dist/css/bootstrap.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "material-icons/iconfont/material-icons.css";
import "vue-awesome-paginate/dist/style.css";
import "vuetify/styles";

window.vueRouter = router;

library.add(
  faHeart,
  faCoffee,
  faSpinner,
  faEdit,
  faTrashAlt,
  faCopy,
  faPlus,
  faPlay,
  faPause,
  faBars,
  faClock,
  faDollarSign,
  faToolbox,
  faUser,
  faRadiation,
  faBaby,
  faAngry,
  faCheck,
);

const app = createApp(App);
const pinia = createPinia();
pinia.use(({ store }) => {
  store.router = markRaw(router);
});

app.use(router);
app.use(VueCookies, { expires: "8h", secure: true });
app.use(pinia);
app.use(dayjs);
app.use(VueAwesomePaginate);
app
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("navbar", Navbar)
  .component("PulseLoader", PulseLoader)
  .component("entriesHistory", entriesHistory)
  .component("clientsChart", clientsChart)
  .component("Dashboard", Dashboard)
  .component("ExportModule", ExportModule)
  .component("Header", Header)
  .component("OfferedAnalysis", OfferedAnalysis)
  .component("OfferedCampaigns", OfferedCampaigns)
  .component("PersonnalReports", PersonnalReports)
  .component("ProductList", ProductList)
  .component("UsageByEntities", UsageByEntities);

app.use(vuetify);


const  link = document.createElement('link');
link.rel = 'stylesheet';
link.href = import.meta.env.VITE_REMOTE_FRONT_APP + 'index.css';
document.head.appendChild(link);

const  link2 = document.createElement('link');
link2.rel = 'stylesheet';
link2.href = import.meta.env.VITE_REMOTE_FRONT_APP + 'output.css';
document.head.appendChild(link2);

await import('remote_broggl_v2/ProtectedPagesLayout');
app.mount("#app");
import "bootstrap/dist/js/bootstrap.js";
